module.exports = __webpack_public_path__ + "static/img/guide04.f60fbbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c29/guide04.jpg
// module id = PPEj
// module chunks = 0